import React, { useState, useEffect } from "react";
import { get_attendance } from "../services/services";
import './modal_asistencias_alumnos.css'
import loadingGif from '../assets/arte.gif';

const ModalAsistencias = ({ isOpen, onClose, userId }) => {
  const [asistencias, setAsistencias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  
  const usuario = JSON.parse(localStorage.getItem("credenciales"));

  const formatDateTime = (dateTimeStr) => {
    const date = new Date(dateTimeStr);
    return {
      fecha: date.toLocaleDateString(),
      hora: date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })
    };
  };

  const formatTiempo = (tiempo) => {
    const minutos = Math.round(tiempo);
    return `${minutos}min`;
  };

  // Pagination calculations
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = asistencias.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(asistencias.length / itemsPerPage);

  const previousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  useEffect(() => {
    console.log('Modal estado:', { isOpen, userId });
    
    const fetchAsistencias = async () => {
      if (!userId) {
        console.log('No hay userId disponible');
        return;
      }
      
      setLoading(true);
      const dataSend = { id: userId };
      
      const dataPromise = new Promise((resolve) => {
        get_attendance(dataSend, usuario, (success, response) => {
          if (success && Array.isArray(response)) {
            const asistenciasOrdenadas = response.sort((a, b) => 
              new Date(b.entrada) - new Date(a.entrada)
            );
            resolve({ success: true, data: asistenciasOrdenadas });
          } else {
            console.log('Error en la respuesta:', response);
            resolve({ 
              success: false, 
              error: 'Error al cargar las asistencias' 
            });
          }
        });
      });

      const delayPromise = new Promise(resolve => 
        setTimeout(resolve, 2000)
      );

      try {
        const [{ success, data, error: responseError }] = await Promise.all([
          dataPromise,
          delayPromise
        ]);

        if (success) {
          setAsistencias(data);
          setCurrentPage(1);
        } else {
          console.error('Error procesando datos:', responseError);
          setError(responseError);
        }
      } catch (err) {
        console.error('Error en la promesa:', err);
        setError('Error al cargar las asistencias');
      } finally {
        setLoading(false);
      }
    };

    if (isOpen) {
      fetchAsistencias();
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [userId, isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-wrapper">
      <div className="modal-overlay" onClick={onClose}>
        <div 
          className="modal-container3"
          onClick={e => e.stopPropagation()}
        >
          {loading && (
            <div className="loading-overlay">
              <div className="loading-content">
                <img 
                  src={loadingGif} 
                  alt="Cargando..." 
                  className="loading-gif"
                />
              </div>
            </div>
          )}
          <div className="modal-content3">
            <div className="modal-header3">
              <h5 className="modal-title3">Asistencias del Usuario</h5>
              <button 
                type="button" 
                className="btn-close3" 
                onClick={onClose}
                aria-label="Close"
              >×</button>
            </div>
            <div className="modal-body1">
              {!loading && error ? (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              ) : !loading && asistencias.length === 0 ? (
                <div className="alert alert-info" role="alert">
                  No hay asistencias registradas
                </div>
              ) : !loading && (
                <div className="table-container">
                  <div className="table-wrapper">
                    <table className="users-table1">
                      <thead>
                        <tr>
                          <th>Fecha</th>
                          <th>Entrada</th>
                          <th>Salida</th>
                          <th>Tiempo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.map((asistencia, index) => {
                          const entradaFormateada = formatDateTime(asistencia.entrada);
                          const salidaFormateada = formatDateTime(asistencia.salida);
                          return (
                            <tr key={index}>
                              <td>{entradaFormateada.fecha}</td>
                              <td>{entradaFormateada.hora}</td>
                              <td>{salidaFormateada.hora}</td>
                              <td>{formatTiempo(asistencia.tiempo)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  
                  <div style={{marginTop:'2%', marginBottom:'4%'}} className="pagination-container">
                    <button 
                      className="page-btn"
                      onClick={previousPage}
                      disabled={currentPage === 1}
                    >
                      Anterior
                    </button>
                    
                    <span className="pagination-info">
                      Página {currentPage} de {totalPages}
                    </span>
                    
                    <button 
                      className="page-btn"
                      onClick={nextPage}
                      disabled={currentPage === totalPages}
                    >
                      Siguiente
                    </button>
                    
                    {/* <span className="pagination-info">
                      10 por página
                    </span> */}
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer3">
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={onClose}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ModalAsistencias };